import React, { Fragment, useState, useEffect } from "react";
import { Typography, Grid, Button, Box, makeStyles } from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { Link, useRouteMatch, useHistory } from "react-router-dom";
import Breadcrumb from "../../../Breadcrumb";

// Images
import sentierBackground from "../../../../images/sentierBackground.jpg";
import obstacles from "../../../../images/pictos-ok/OBSTACLES.svg";
import difficulte_passsage from "../../../../images/pictos-ok/DIFFICULTE.svg";
import fermeture from "../../../../images/pictos-ok/FERMETURE.svg";

import Theme, { useStyles } from "../../../Theme.js";

const ChooseEtatTheme = () => {
  const classes = useStyles();
  const history = useHistory();
  let { url } = useRouteMatch();
  const [destination, setDestination] = useState();

  /**
   * @Description Set le state destination à l'URL qu'il faudra rejoindre
   * @param {*} event
   */
  const handleNav = (event) => {
    setDestination(event.currentTarget.getAttribute("destination"));
    history.push(event.currentTarget.getAttribute("destination"));
  };

  /**
   * @Description Se rend à l'URL indiqué dans le state destination
   */
  const handleGo = () => {
    destination
      ? history.push(destination)
      : // Si pas de destination : affichage d'un message pour le user
        alert(
          "Veuillez indiquer votre réponse avant de passer à l’étape suivante "
        );
  };

  return (
    <Fragment>
      <Breadcrumb size={8} current={2} />
      <Box
        className={classes.subHeader}
        style={{ marginTop: 20, justifyContent: "center" }}
      >
        <Typography variant="h3" className={classes.subHeaderTitle}>
          L'état du sentier
        </Typography>
        <Typography variant="body1" style={{ fontSize: 12 }}>
          Avez-vous rencontré un obstacle, une difficulté ou un sentier
          impraticable ?
        </Typography>
      </Box>
      <Grid container spacing={2} style={{ maxWidth: "100%" }}>
        {/* Première ligne */}
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
          <Button
            destination={`${url}/obstacles`}
            className={classes.themeButton}
            onClick={handleNav}
            classes={{ label: "labelButton" }}
          >
            <img
              src={obstacles}
              alt="{à venir}"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Obstacles
          </Button>
        </Grid>
        {/* Deuxième ligne */}
        <Grid
          item
          xs={6}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            destination={`${url}/difficultes`}
            className={classes.themeButton}
            onClick={handleNav}
            classes={{ label: "labelButton" }}
          >
            <img
              src={difficulte_passsage}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Difficulté de passage
          </Button>
        </Grid>
        <Grid item xs={6} style={{ display: "flex", alignItems: "flex-start" }}>
          <Button
            destination={`${url}/ferme`}
            className={classes.themeButton}
            onClick={handleNav}
            classes={{ label: "labelButton" }}
          >
            <img
              src={fermeture}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Sentier fermé
          </Button>
        </Grid>
        {/* Troisième ligne */}
        <Box className={"suivantprecedent " + classes.boxButton}>
          <Button
            className={classes.navButton}
            onClick={() => history.push("/observation/sentier")}
          >
            <ArrowRightAltIcon style={{ transform: "rotate(0.5turn)" }} />
            Etape précédente
          </Button>

          <Button className={classes.navButton} onClick={handleGo}>
            Etape suivante <ArrowRightAltIcon />
          </Button>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default ChooseEtatTheme;
